import { NgModule } from "@angular/core";
import { UserPopoverButtonComponent } from "./user-popover-button.component";
import { IonicModule } from "ionic-angular";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        UserPopoverButtonComponent
    ],
    exports: [
        UserPopoverButtonComponent
    ]
})
export class UserPopoverButtonModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-other/user-popover-button/user-popover-button.module.ts